function Copyright() {
  return <p>Copyright {new Date().getFullYear()} &copy; Urbain Hospitality Group Inc.</p>;
}

export default Copyright;
